import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useThemeWithUndefined } from '@rescui/ui-contexts';
import styles from '../index.p.module.css.js';
import { useMenuContext } from './menu-context.js';
const THEME_CLASS = {
  light: styles.themeLight,
  dark: styles.themeDark
};

const Divider = _ref => {
  let {
    className,
    theme,
    ...restProps
  } = _ref;
  const menuContext = useMenuContext();
  const actualTheme = useThemeWithUndefined(menuContext.theme ?? theme);
  return /*#__PURE__*/React.createElement("hr", {
    className: cn(styles.divider, THEME_CLASS[actualTheme], className),
    ...restProps
  });
};

Divider.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark'])
};
export { Divider as default };
